import axios from "axios";
const apiAdder = process.env.VUE_APP_API;
export async function getList() {
  const token = localStorage.getItem("token");
  return axios
    .get(`${apiAdder}ticket/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}
export async function sendTicket(_, data) {
  const token = localStorage.getItem("token");
  return axios
    .post(`${apiAdder}ticket/`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((rsp) => {
      return rsp.data;
    });
}
